import React from "react";
import { emitRecommenderRequest, FromProduct } from "@catchoftheday/analytics";
import { getProductTiles } from "@catchoftheday/product-app";
import { usePersonalisedProductRecommendationsQuery } from "@common-vendors/generated/graphql";
import {
  RecommenderCarousel,
  getRecommenderTrackingData,
} from "../RecommenderCarousel";

type PersonalisedProductRecommenderProps = {
  limit: number;
  adult: boolean;
  fromProduct: FromProduct;
  sourceId: string;
  sourceType: number;
};

export const PersonalisedProductRecommender = ({
  limit,
  adult,
  fromProduct,
  sourceId,
  sourceType,
}: PersonalisedProductRecommenderProps) => {
  const { data, error } = usePersonalisedProductRecommendationsQuery({
    variables: { limit, adult },
    ssr: false,
    onCompleted: ({
      personalisedRecommendedProducts: {
        metaData: {
          preHydrationCount,
          postHydrationCount,
          hydrationErrorCount,
        },
      },
    }) => {
      emitRecommenderRequest({
        source_type: sourceType,
        pre_hydration_product_count: preHydrationCount,
        post_hydration_product_count: postHydrationCount,
        hydration_error_count: hydrationErrorCount,
        ...fromProduct,
      });
    },
  });

  if (!data?.personalisedRecommendedProducts.products.length || error) {
    return null;
  }

  const products = data.personalisedRecommendedProducts.products;
  const tiles = getProductTiles({
    products,
    sourceType,
    sourceId,
    fromProduct,
  });
  const trackingData = getRecommenderTrackingData(products, "product");

  return (
    <RecommenderCarousel
      tiles={tiles}
      heading="Recommended For You"
      sourceType={sourceType}
      trackingData={trackingData}
      fromProduct={fromProduct}
    />
  );
};
